<template>
  <div class="page-con">
    <div class="page-con-header clearfix">
      <Button type="primary" icon="ios-add" v-if="isHavePermission('eleContract:create')" @click="showDialog">新建电子合同
      </Button>
      <vxe-button icon="vxe-icon--refresh" @click="refresh"
                  :style="isHavePermission('eleContract:create') ? 'margin-left: 20px' :''">刷新
      </vxe-button>
      <div class="search-filter">
        <Poptip placement="bottom-end" width="680" v-model="searchVisible">
          <em>
            <Icon type="ios-search-outline"/>
            搜索
          </em>
          <div class="search-box" slot="content">
            <vxe-form :data="searchFormData" title-align="left">
              <vxe-form-item
                  title="搜索"
                  field="receiveNum"
                  span="24"
                  :prefix="{ icon: 'fa fa-address-card-o' }"
              ></vxe-form-item>
              <vxe-form-item title="合同编号" field="contractSn" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.contractSn"
                      placeholder="输入合同编号"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="合同标题" field="docTitle" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.docTitle"
                      placeholder="输入合同标题"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="发起方名称" field="sponsorName" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.sponsorName"
                      placeholder="输入发起方名称"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="客户名称" field="otherName" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.otherName"
                      placeholder="输入客户名称"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="平台公司签时间" field="sponserSignTime" span="12">
                <template v-slot>
                  <vxe-select
                      v-model="searchFormData.sponsorSignTime"
                      :options="timeOptions"
                      placeholder="选择时间"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="客户签署时间" field="otherSignTime" span="12">
                <template v-slot>
                  <vxe-select
                      v-model="searchFormData.otherSignTime"
                      :options="timeOptions"
                      placeholder="选择时间"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item align="right" span="24">
                <template v-slot>
                  <Button status="primary" icon="ios-search" @click="list" style="border-radius: 5px">搜索
                  </Button>
                  <Button @click="reset" style="margin-left: 10px; border-radius: 5px">重置
                  </Button>
                </template>
              </vxe-form-item>
            </vxe-form>
          </div>
        </Poptip>
        <div class="search-filter">
          <vxe-modal
              class="timeModal"
              v-model="open"
              width="460"
              height="400"
              :show-footer="false"
              :showHeader="false"
          >
            <template v-slot>
              <DatePicker
                  :open="open"
                  confirm
                  type="daterange"
                  :split-panels="true"
                  placeholder
                  style="width: 432px"
                  @on-change="handleChange"
                  @on-clear="handleClear"
                  @on-ok="handleOk"
              >
                <span class="date-slot"></span>
              </DatePicker>
            </template>
          </vxe-modal>
        </div>
      </div>
    </div>
    <div class="list-box common-shadow clearfix">
      <vxe-table
          class="table-style"
          highlight-hover-row
          show-footer
          stripe
          align="center"
          border="none"
          show-overflow
          max-height="740"
          :loading="loading"
          :data="tableData"
          @filter-change="filterChangeMethod"
      >
        <vxe-table-column title="操作" width="90">
          <template slot-scope="{ row }">
            <Dropdown trigger="click" style="margin-left: 10px; cursor: pointer" transfer>
              <icon type="text" custom="iconfont icon-gengduo" size="12px"></icon>
              <DropdownMenu slot="list" style="left: 70px">
                <div style="display: flex; flex-direction: column">
                  <Button class="button-gengduo" v-if="row.status === 0 && isHavePermission('eleContract:edit')"
                          @click="openEditView(row.id)">编辑
                  </Button>
                  <!--                  <Button class="button-gengduo" v-if="row.status === 0 || row.status === 4"-->
                  <!--                          @click="getCompSignUrl(row.id)">去签署-->
                  <!--                  </Button>-->
                  <Button class="button-gengduo" v-if="isHavePermission('eleContract:download')"
                          @click="downloadContract(row.id)">下载合同
                  </Button>
                  <Button class="button-gengduo" v-if="row.status === 1 && isHavePermission('eleContract:cancel')"
                          @click="commitCancel(row.id)">撤回
                  </Button>
                  <Button class="button-gengduo" @click="commitDelete(row.id)"
                          v-if="row.status === 0 || row.status === 4 && isHavePermission('eleContract:delete')"
                          style="color: #ed4014">删除
                  </Button>
                </div>
              </DropdownMenu>
            </Dropdown>
          </template>
        </vxe-table-column>
        <vxe-table-column field="contractSn" title="合同编号" width="150">
          <template slot-scope="{ row }">
            <a v-if="isHavePermission('eleContract:view')" @click="viewContract(row.id)">{{ row.contractSn}}</a>
            <span v-else>{{ row.contractSn}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="docTitle" title="合同名称" width="120"></vxe-table-column>
        <vxe-table-column field="status" title="合同状态"
                          :filters="[{label: '未发起', value: 0}, {label: '待签署', value: 1},{label: '已签署', value: 2}, {label: '已拒绝', value: 3},{label: '已撤回', value: 4}]"
                          :filter-multiple="false">
          <template slot-scope="{ row }">
            <span>{{ row.status | status }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="sponsorName" title="发起方">
          <template slot-scope="{ row }">
            <span>{{ row.sponsorName }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="otherName" title="签署方"></vxe-table-column>
        <vxe-table-column field="sponsorSignTime" title="平台发起日期">
          <template slot-scope="{ row }">
            <span>{{ row.sponsorSignTime | timeFormatDate}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="otherSignTime" title="客户签署日期">
          <template slot-scope="{ row }">
            <span>{{ row.otherSignTime | timeFormatDate}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="effectiveTime" title="生效日期">
          <template slot-scope="{ row }">
            <span>{{ row.effectiveTime | timeFormatDate}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="expirationTime" title="终止日期">
          <template slot-scope="{ row }">
            <span>{{ row.expirationTime | timeFormatDate}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="createTime" title="创建日期">
          <template slot-scope="{ row }">
            <span style="color: #a7adad">{{ row.createTime | timeFormatDate}}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :total="page.totalResult"
          @page-change="changePage"
      ></vxe-pager>
    </div>
    <vxe-modal v-model="isShowModal" :title="modalTitle" width="1000" height="500" position="center" resize @close="closeModal">
      <create-ele-modal ref="eleModal" @close="close"></create-ele-modal>
    </vxe-modal>
  </div>
</template>

<script>
  import $api from "@/apiProvider";
  import $C from "@/consts";
  import {SEARCH_TIME} from "@/filters/time";
  import moment from "moment";
  import getAuthOrization from "@/mixin/getAuthOrization";
  import {getBlob, hideLoading, isEmpty, saveBlob, showLoading,} from "@/utils/util";
  import CreateEleModal from "@/views/agreement/CreateEleModal";

  moment.locale("zh-CN");

  export default {
    name: "EleContract",
    components: {CreateEleModal},
    mixins: [getAuthOrization],
    data() {
      return {
        searchLoading: false,
        searchVisible: false,
        open: false,
        timeOptions: SEARCH_TIME.options,
        loading: false,
        modalTitle: "",
        tableData: [],
        searchFormData: {
          contractSn: null,
          docTitle: null,
          otherName: null,
          sponsorName: null,
          sponsorSignTime: null,
          otherSignTime: null,
          status: null,
        },
        page: {
          currentPage: 1,
          pageSize: 10,
          totalResult: 100,
        },
        isShowModal: false
      };
    },
    watch: {
      "searchFormData.sponsorSignTime": {
        deep: true,
        immediate: true,
        handler: function (val, oldVal) {
          this.openRangeDate("sponsorSignTime");
        },
      },
      "searchFormData.otherSignTime": {
        deep: true,
        immediate: true,
        handler: function (val, oldVal) {
          this.openRangeDate("otherSignTime");
        },
      },
    },
    filters: {
      status(val) {
        if (val != null) {
          if (val === 0) {
            return "未发起";
          }
          if (val === 1) {
            return "待签署";
          }
          if (val === 2) {
            return "已签署";
          }
          if (val === 3) {
            return "已拒绝";
          }
          if (val === 4) {
            return "已撤回";
          }
        }
      },
    },
    mounted() {
      this.list();
    },
    methods: {
      filterChangeMethod({values}) {
        this.page.currentPage = 1;
        if (values.length > 0) {
          this.searchFormData.status = values[0];
        } else {
          this.searchFormData.status = null;
        }
        this.list()
      },
      async getCompSignUrl(id) {
        showLoading();
        let res = await $api.eleContract.post("getCompSignUrl", {
          id: id,
          returnUrl: process.env.VUE_APP_LOGIN + '/agreement/eleContract'
        });
        hideLoading();
        if (res.status === 1) {
          window.location.href = res.data;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      async downloadContract(id) {
        showLoading();
        let res = await $api.eleContract.post("downloadContract", {
          id: id
        });
        hideLoading();
        if (res.status === 1) {
          window.open(res.data);
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      async viewContract(id) {
        showLoading();
        let res = await $api.eleContract.post("viewContract", {
          id: id
        });
        hideLoading();
        if (res.status === 1) {
          window.open(res.data);
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      openEditView(id) {
        this.modalTitle = '编辑电子合同';
        this.isShowModal = true;
        this.$nextTick(() => {
          this.$refs.eleModal.showDetail(id);
        })
      },
      closeModal() {
        this.$refs.eleModal.reset();
      },
      close() {
        this.isShowModal = false;
      },
      showDialog() {
        this.modalTitle = '新建电子合同';
        this.isShowModal = true;
      },
      reset() {
        this.searchFormData = {
          contractSn: null,
          docTitle: null,
          otherName: null,
          sponsorName: null,
          sponsorSignTime: null,
          otherSignTime: null,
          status: null,
        };
      },
      openRangeDate(field) {
        if (this.searchFormData[field] === 1) {
          this.rangeTime = field;
          this.open = true;
        } else {
          this.open = false;
        }
      },
      handleChange(date) {
        this.timeVal = date;
        // this.timeVal = date.map( v => moment(v).valueOf());
        console.log(this.timeVal);
      },
      handleClear() {
      },
      handleOk() {
        this.searchFormData[this.rangeTime] = this.timeVal;
        this.rangeTime = false;
        let that = this;
        setTimeout(() => {
          that.searchVisible = true;
        }, 100);
      },
      refresh() {
        this.list();
      },
      async list() {
        let sponsorSignTime = this.searchFormData.sponsorSignTime;
        let sponsorSignTimeBegin = null;
        let sponsorSignTimeEnd = null;
        if (sponsorSignTime && sponsorSignTime.length > 0) {
          sponsorSignTimeBegin = moment(sponsorSignTime[0]).valueOf(); // 开始时间
          sponsorSignTimeEnd = moment(sponsorSignTime[1]).valueOf() + 86399999; // 结束时间
        }
        let otherSignTime = this.searchFormData.otherSignTime;
        let otherSignTimeBegin = null;
        let otherSignTimeEnd = null;
        if (otherSignTime && otherSignTime.length > 0) {
          otherSignTimeBegin = moment(otherSignTime[0]).valueOf(); // 开始时间
          otherSignTimeEnd = moment(otherSignTime[1]).valueOf() + 86399999; // 结束时间
        }
        this.loading = true;
        let res = await $api.eleContract.request("list", {
          contractSn: this.searchFormData.contractSn,
          docTitle: this.searchFormData.docTitle,
          otherName: this.searchFormData.otherName,
          sponsorName: this.searchFormData.sponsorName,
          status: this.searchFormData.status,
          sponsorSignTimeBegin: sponsorSignTimeBegin,
          sponsorSignTimeEnd: sponsorSignTimeEnd,
          otherSignTimeBegin: otherSignTimeBegin,
          otherSignTimeEnd: otherSignTimeEnd,
          page: this.page.currentPage,
          rows: this.page.pageSize,
        });
        if (res.status === 1) {
          this.page.totalResult = res.data.total;
          this.tableData = res.data.rows;
          this.loading = false;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      commitCancel(id) {
        this.$XModal.confirm("您确定要撤回吗？").then((type) => {
          if (type === "confirm") {
            this.cancel(id);
          }
        });
      },
      commitDelete(id) {
        this.$XModal.confirm("您确定要删除吗？").then((type) => {
          if (type === "confirm") {
            this.delete(id);
          }
        });
      },
      async cancel(id) {
        let res = await $api.eleContract.request("cancel", {
          id: id,
        });
        if (res.status === 1) {
          this.$Message.success("撤回成功");
          this.list();
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      async delete(id) {
        let res = await $api.eleContract.request("delete", {
          id: id,
        });
        if (res.status === 1) {
          this.$Message.success("删除成功");
          this.list();
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      changePage(e) {
        this.page.currentPage = e.currentPage;
        this.page.pageSize = e.pageSize;
        this.list();
      },
    },
  };
</script>

<style>
  .btn-down {
    border: none;
  }

  .btn-down:focus {
    outline: none;
    border-color: transparent;
    box-shadow: none;
    background: transparent;
  }

  .page-con-header {
    margin-bottom: 10px;
    position: relative;
  }

  .btn-down.ivu-btn {
    background: transparent;
  }

  .btn-down.ivu-btn:hover {
    background: transparent;
  }

  .trackBox {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0px;
    top: 0px;
    z-index: 100;
    background: #fff;
  }
</style>